import { graphql } from '@graphql/gql';

export const GET_ATTENDEE_HUB_CONFIG = graphql(`
  query GET_ATTENDEE_HUB_CONFIG($locale: String) {
    getAttendeeHubConfig(locale: $locale) {
      featureSettings {
        id
        type
        featureCode
        isEnabled
        metadata
      }
      mobileAssets {
        eventImageUrl
        eventImageName
        eventImageUrlOptimized
        lastModifiedDate
      }
      morePageSettings {
        pageGroups {
          id
          name
          pages
          description
        }
      }
      customPageSettings {
        id
        pageId
        pageName
        pageIcon
        description
        imageAsset
        lastModifiedDate
        pageType
        externalUrl
        documentAsset
      }
      pageBannerPageSettingsBulk {
        id
        location
        locationId
        placements {
          id
          bannerId
          location
          visibility
          activeTimes {
            startTime
            endTime
          }
        }
        placementOrder
        rotationInterval
        lastModifiedDate
      }
      pageBannerSettings {
        id
        name
        template
        imageAsset {
          assetUriOptimized
          altText
        }
        title
        body
        linkText
        linkDestinationType
        linkAttendeeHubDestinationType
        linkDestination
        exhibitorAttribution
        textAlignment
        imageAlignment
        fontColor
        containerBackground
        containerBackgroundCustomColor
      }
      privacySettings {
        attendeesVisible
      }
      securitySettings {
        documentSharingEnabled
      }
    }
  }
`);
